import { CatalogSelect } from '../ui/CatalogSelect'
import { SearchFilter } from '../ui/SearchFilter'

interface ProductDiscoveryControlsProps {
  search: string
  useCaseId: string
  onSearchChange: (value: string) => void
  onUseCaseChange: (value: string) => void
}

export function ProductDiscoveryControls({
  search,
  useCaseId,
  onSearchChange,
  onUseCaseChange,
}: ProductDiscoveryControlsProps) {
  return (
    <>
      <div className="mb-4 grid gap-3 md:grid-cols-[minmax(0,1fr)_240px]">
          <div className="relative w-full">
            <SearchFilter
              id="product-search-input"
              initialValue={search}
              placeholder="Buscar por nombre, sustancia o código..."
              onSearch={(value) => onSearchChange(value)}
              className="w-full"
              autoComplete="off"
            />
          </div>

          <CatalogSelect
            catalog="pos/use-cases"
            placeholder="Todos los casos de uso"
            value={useCaseId === 'all' ? '' : useCaseId}
            onChange={(value: unknown) => {
              onUseCaseChange(typeof value === 'string' || typeof value === 'number' ? String(value) : 'all')
            }}
            className="h-10 !border-slate-500"
          />
        </div>

    </>
  )
}
